import Vue from "vue";

export default {
    resetStateMutation(state) {
        Vue.set(state, "roleFormIsOpen", false);
        Vue.set(state, "roleGridIsOpen", true);
        Vue.set(state, "permissionFormIsOpen", false);
        Vue.set(state, "permissionGridIsOpen", false);
    },
    setRoleFormOpen(state) {
        state.roleFormIsOpen = true;
        state.roleGridIsOpen = false;
        state.permissionFormIsOpen = false;
        state.permissionGridIsOpen = false;
    },
    setRoleFormClose(state) {
        state.roleFormIsOpen = false;
        state.roleGridIsOpen = true;
        state.permissionFormIsOpen = false;
        state.permissionGridIsOpen = false;
    },

    setPermissionFormOpen(state) {
        state.roleFormIsOpen = false;
        state.roleGridIsOpen = false;
        state.permissionFormIsOpen = true;
        state.permissionGridIsOpen = false;
    },
    setPermissionFormClose(state) {
        state.roleFormIsOpen = false;
        state.roleGridIsOpen = false;
        state.permissionFormIsOpen = false;
        state.permissionGridIsOpen = true;
    }
}
